/** Namespaced, failure tolerant localStorage helpers. */

const PREFIX = "jumble:"

export function readStorage<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(PREFIX + key)
    if (raw === null) return fallback
    return JSON.parse(raw) as T
  } catch {
    return fallback
  }
}

export function writeStorage(key: string, value: unknown): void {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(value))
  } catch {
    // storage can be disabled (private mode) or full; never break the UI for it
  }
}

export function removeStorage(key: string): void {
  try {
    localStorage.removeItem(PREFIX + key)
  } catch {
    // ignore
  }
}

export function readString(key: string): string | undefined {
  try {
    return localStorage.getItem(PREFIX + key) ?? undefined
  } catch {
    return undefined
  }
}

export function writeString(key: string, value: string): void {
  try {
    localStorage.setItem(PREFIX + key, value)
  } catch {
    // ignore
  }
}

export const StorageKeys = {
  theme: "theme",
  settings: "settings",
  favoriteRelays: "favoriteRelays",
  relaySets: "relaySets",
  feedInfo: "feedInfo",
  account: "account",
  searchHistory: "searchHistory",
  bookmarks: "bookmarks",
  readOnlyPubkey: "readOnlyPubkey",
} as const
